import { useRef } from 'react'
import { useAliveController } from 'react-activation'
import Manager from '../../core/manager'

let manager: any = null

export const setManager = (e: any) => {
    manager = e
}

export const getManager = () => {
    return manager
}

export default ({
    history,
    scroller,
    defaultUseCache,
    routes,
    matchRoute,
    unDropMicroApp,
    ignoreVisitedKeys,
    refreshMicroApp,
    onVisitedChange
}: any) => {
    const aliveController = useAliveController()

    const managerRef = useRef<any>(null)

    if (!managerRef.current) {
        managerRef.current = new Manager({
            history,
            routes,
            matchRoute,
            aliveController,
            scroller,
            unDropMicroApp,
            ignoreVisitedKeys,
            defaultUseCache,
            refreshMicroApp,
            onVisitedChange
        })

        setManager(managerRef.current)
    }

    return {
        manager: managerRef.current
    }
}
